const insurancePageStyle = (theme) => ({
  insuranceCard: {
    margin: "10px 0px 0px 0px",
  },
  marginTopDialogTitle: {
    marginTop: "15px",
  },
  insuranceSection: {
    ...theme.arrowItem,
    padding: "0 0px",
    height: "100px",
  },
  brandName: {
    ...theme.ellipsisLabel,
    fontSize: "15px",
  },
  assetName: {
    ...theme.ellipsisLabel,
    fontFamily: "SparBd",
    fontSize: "20px",
  },
  kindOfObjectName: {
    ...theme.ellipsisLabel,
    fontFamily: "SparBd",
    fontSize: "20px",
  },
  mediumFont: {
    fontSize: "15px",
  },
  arrowTipItem: (props) => {
    return {
      ...theme.arrowTipItem,
      height: "100%",
      "&:after": {
        ...theme.arrowTipItem["&:after"],
        borderTop: props.arrowItemHeight / 2 + "px solid transparent",
        borderBottom: props.arrowItemHeight / 2 + "px solid transparent",
      },
    };
  },
  insuranceType: {
    padding: "10px 0px 0 30px",
  },
});

export default insurancePageStyle;
